define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
    const invitation_model = require('civicsModels/portal/invitation_model');
    const constants = require('civicsUtils/constants');
    const urlBuilder = require('civicsUtils/buildUrlParameters');

    return IpsModelCollection.extend({
  		model: invitation_model,
      urlRoot: '/delegate/civics-api/api/portal/invitations',
      url: function() {
        var ret = this.urlRoot;
        if (this.instrumentNumber && this.productFamily) {
            ret += '/' + this.productFamily + '/' + this.instrumentNumber;
        }
        //an assumption that when request ExpiredDate's value is a valid date,
        //it adds the filter to get invites having dates later than request's this.expiredDate value
        if(this.expiredDate != null && this.expiredDate > constants.DATE_TIME_MIN_VAL){
              var parms = urlBuilder.buildUrlParameters({
                extendedFilter:{
                  Or: [{
                    property:'ExpiredDate',
                    operator:'IsNull'
                  },{
                    property:'ExpiredDate',
                    value:this.expiredDate,
                    operator:'GreaterThan'
                  }]
                }
              });
         		ret += parms;
         	}

         return ret;
      }
    });
});
